<template>

    <div v-if='isReady' class="row single-model-info">

        <div class="col-12 d-flex justify-content-center mb-4">
            <span class="border-grid img-link d-inline-block profile-image">        
                <img :alt="model.name" 
                     :src="model.avatar" class="img-fluid">
            </span>
        </div>

        <div class="col-12 d-flex justify-content-center align-items-center mb-3">
            <h2 class="page-title text-uppercase mb-0 text-center text-md-left">
                {{ model.name }}
            </h2>
        </div>

        <div v-if='model.only_fans' class="col-12 d-flex justify-content-center align-items-center mb-3">
            <a :href="model.only_fans" target="_blank" class="btn btn-primary btn-lg" title="OnlyFans">
                <span class="icon icon-onlyfans"></span>
                OnlyFans
            </a>
        </div>
        
        <div class="col-12 d-flex justify-content-center align-items-center">        
            <!-- Social Icons -->
            <ul class="list-inline d-flex align-items-center">

                <li v-if='model.instagram' class="list-inline-item model-social">
                    <a :href="model.instagram" target="_blank" title="Instagram">
                        <span class="icon icon-instagram"></span>
                    </a>
                </li>

                <li v-if='model.twitter' class="list-inline-item model-social ml-3">
                    <a :href="model.twitter" target="_blank" title="Twitter">
                        <span class="icon icon-twitter"></span>
                    </a>
                </li>

                <li v-if='model.telegram' class="list-inline-item model-social ml-3">
                    <a :href="model.telegram" target="_blank" title="Telegram">
                        <span class="icon icon-telegram"></span>
                    </a>
                </li>

            </ul>
                
        </div>

        <div class="col-12 d-flex justify-content-center page-footer-link">
            <a href="https://ofmdb.com" target="_blank">Trending OnlyFans Models</a>
        </div>

    </div>

</template>

<script>
    export default {

        mounted() {


        },

        created() {

            if( typeof this.slug == 'string' && this.slug ) {
                this.getData();
            }

        },

        props : ['slug'],

        data() {
            return {
                isReady : false,
            }
        },

        methods : {

            getData() {
                this.ajax.call('mdl:gspd', { m : this.slug }, (r) => {
                    
                    if ( r.status == 'success' ) {

                        this.model  = r.data.model;
                        this.videos = r.data.v;
                        this.images = r.data.i;

                        this.isReady = true;
                        this.$nextTick(this.initToggleTxt);
                    }

                })
            }
        }

    }
</script>
